module.exports = __webpack_public_path__ + "img/feature_buy_th.882a3212.png";